import { Link } from "react-router-dom";
import { SEO } from "../components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found" />
      <section className="pt-48 pb-32 px-6 text-center">
        <p className="font-mono-tag text-gold text-sm uppercase tracking-widest mb-4">404</p>
        <h1 className="font-display font-black text-4xl text-white">This page doesn't exist</h1>
        <Link to="/" className="inline-flex mt-8 h-11 px-6 items-center bg-primary hover:bg-[#5C7CFA] text-white text-sm font-medium rounded-sm transition-colors">Back to Home</Link>
      </section>
    </>
  );
}
